import { API } from "@/lib/api";
import { APIService, FetchListRequest } from "@/services/api";
import { DisplayProjectManager } from "@/types/projectManager";

const ProjectManagersServiceAPI = new APIService<DisplayProjectManager>(
  API.Projects,
);

export const ProjectManagersService = {
  getList: (
    projectId: string,
    fetchParams?: FetchListRequest<DisplayProjectManager>,
  ) => ProjectManagersServiceAPI.getList(fetchParams, `/${projectId}/managers`),
  getAvailableList: (
    projectId: string,
    fetchParams?: FetchListRequest<DisplayProjectManager>,
  ) =>
    ProjectManagersServiceAPI.getList(
      fetchParams,
      `/${projectId}/managers/available`,
    ),
  addUsers: (projectId: string, users: string[]) =>
    ProjectManagersServiceAPI.patch(projectId, { add: users }, `managers`),
  removeUsers: (projectId: string, users: string[]) =>
    ProjectManagersServiceAPI.patch(projectId, { delete: users }, `managers`),
};
